import { FC, ReactNode } from "react";
import Box from "@mui/material/Box";

interface AppLayoutProps {
  children: ReactNode;
  /**
   * Removes the floating-card inset (outer padding + rounded corners) so the
   * content sits flush to the shell edges. Used by dense, space-constrained
   * views such as the segments explore page.
   */
  disablePadding?: boolean;
}

export const AppLayout: FC<AppLayoutProps> = ({
  children,
  disablePadding = false,
}) => {
  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f9fafb",
        minWidth: 0, // Allows flex item to shrink below content size
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
        overflowY: "auto",
        overflowX: "hidden",
        padding: disablePadding ? 0 : "12px",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: disablePadding ? 0 : "10px",
          overflow: "auto",
          overflowX: "hidden",
          minHeight: 0,
          minWidth: 0,
          maxWidth: "100%",
          width: "100%",
          boxSizing: "border-box",
          padding: 0,
        }}
      >
        {children}
      </div>
    </Box>
  );
};
